import axios from 'axios'


import {
  defineStore
} from 'pinia'

export const useCollectionStore = defineStore('CollectionStore', {
  state: () => {
    return {
      quickViewProduct: null,
      showQuickView: false,
      baseUrl: window.location.pathname,
      jsonEndpoint: '&view=json',
      collection: {
        products: []
      },
      filterSlideoutIsOpen: false
    }
  },

  actions: {
    setQuickViewProduct (product) {
      this.quickViewProduct = product
      this.showQuickView = true
    },
    hideQuickView () {
      this.showQuickView = false
    },
    setupCollection () {
      this.collection = {
        ...window.theme.collection
      }
    },
    toggleFilterDropdown (index) {
      this.collection.filters.forEach((filter, i) => {
        if (i === index) {
          this.collection.filters[i].isOpen = !this.collection.filters[i].isOpen
        } else {
          if (window.outerWidth > 768) {
            this.collection.filters[i].isOpen = false
          }
        }
      })
    },
    closeFilterDropdown () {
      if (window.outerWidth > 768) {
        this.collection.filters.forEach((filter, i) => {
          if (filter.isOpen) {
            this.collection.filters[i].isOpen = false
            return
          }
        })
      }
    },
    toggleFilter(filterIndex, valueIndex) {
      const alreadyChecked = this.collection.filters[filterIndex].values[valueIndex].active
      if (alreadyChecked) {
        this.collection.filters[filterIndex].activeFilters -= 1
      } else {
        this.collection.filters[filterIndex].activeFilters += 1
        this.collection.paginate.current_page = 1
      }
      this.collection.filters[filterIndex].values[valueIndex].active = !this.collection.filters[filterIndex].values[valueIndex].active
    },

    async changeSorting (newSortValue) {
      if (newSortValue != this.sortBy) {
        this.collection.sorting.sortBy = newSortValue

        await axios.get(this.sortByJsonUrlParameter)
        .then(async ({ data }) => {
          this.collection.products = [...this.collection.products].sort((a, b) => {
            const sortedMatch1 = data.products.find(product => product.handle === a.handle)
            const sortedMatch2 = data.products.find(product => product.handle === b.handle)
            return sortedMatch1.position < sortedMatch2.position ? -1 : 1
          })

          this.updateUrl()
        })
        .catch((e) => {
          console.error(e)
        })
      }
    },

    updateUrl () {
      const newUrl = this.baseUrl + this.sortByUrlParameter
      history.replaceState({}, null, newUrl)
    },

    clearFilters () {
      this.collection.filters.forEach((filterGroup, i) => {
        if (filterGroup.values) {
          filterGroup.values.forEach((value, index) => {
            this.collection.filters[i].activeFilters = 0
            if (value.active) {
              this.collection.filters[i].values[index].active = false
            }
          })
        }
      })
    },

    openMobileFilters () {
      this.filterSlideoutIsOpen = true
      document.body.classList.add('overflow-hidden')
    },

    closeMobileFilters (event) {
      if (window.outerWidth <= 768) {
        if (event.target.hasAttribute('data-close')) {
          this.filterSlideoutIsOpen = false
          document.body.classList.remove('overflow-hidden')
        }
      }
    },

    loadMore () {
      this.collection.paginate.current_page += 1
    }

  },

  getters: {
    productCount () {
      return this.productsFiltered.length
    },

    highlightedProducts () {
      return this.collection.highlightedProducts
    },
    collectionFilters () {
      if (!this.collection.filters) return []

      return this.collection.filters.filter(filterGroup => filterGroup.values.length > 0)
    },
    activeCollectionFilters () {
      if (!this.collection.filters) return []

      const filters = this.collection.filters.map(filter => {
        if (filter.values) {
          const activeFilterValues = filter.values.filter(value => { return value.active })
          if (activeFilterValues.length > 0) {
            return {
              ...filter,
              values: activeFilterValues
            }
          }
        }
      })

      return filters.filter(filter => filter)
    },
    totalActiveFilters () {
      let count = 0
      this.activeCollectionFilters.forEach(filter => {
        count += filter.activeFilters
      })
      return count
    },
    collectionIsFiltered () {
      return this.activeCollectionFilters.length > 0
    },
    pagination () {
      return this.collection.paginate
    },
    sortBy () {
      if (!this.collection.sorting) return []

      return this.collection.sorting.sortBy
    },
    sortByJsonUrlParameter () {
      return `${this.sortByUrlParameter}${this.jsonEndpoint}`
    },
    sortByUrlParameter () {
      return `?sort_by=${this.sortBy}`
    },
    sortOptions () {
      if (!this.collection.sorting) return []

      return this.collection.sorting.sortOptions.filter(option => !option[0].includes('price'))
        .map(option => {
          return {
            value: option[0],
            label: option[1],
          }
        })
    },
    productsFiltered () {
      if (!this.collectionIsFiltered) return this.collection.products

      return this.collection.products.filter(product => {
        let validProduct = true
        this.activeCollectionFilters.forEach(filter => {
          let validProductWithinFilterGroup = false
          /*
            Availability filters
          */
          if (filter.label === 'Availability') {
            filter.values.forEach(value => {
              if (value.label === 'In stock') {
                if (product.available) {
                  validProductWithinFilterGroup = true
                }
              } else if (value.label === 'Out of stock') {
                if (!product.available) {
                  validProductWithinFilterGroup = true
                }
              }
            })
          }

          /*
            Tag filters
          */
          else if (filter.paramName === 'filter.p.tag') {
            filter.values.forEach(value => {
              if (product.tags.includes(value.label)) {
                validProductWithinFilterGroup = true
              }
            })
          }

          /*
            Size filters
          */
          else if (filter.paramName === 'filter.v.option.size') {
            const availableVariants = product.variants.filter(variant => variant.available)

            filter.values.forEach(value => {
              if (availableVariants.find(variant => variant.title === value.label)) {
                validProductWithinFilterGroup = true
              }
            })
          }

          /*
            If product does not match any of the filters within
            the current filter group
            product does not pass filters
          */
          if (!validProductWithinFilterGroup) {
            validProduct = false
          }
        })
        return validProduct
      })
    },

    productsPaginated () {
      const productPages = []
      for (let i = 0; i < this.productsFiltered.length; i += this.pagination.page_size) {
        const page = this.productsFiltered.slice(i, i + this.pagination.page_size)
        productPages.push(page)
      }
      return productPages
    },

    currentPageProducts () {
      if (!this.pagination) return []
      let products = []
      for (let i = 0; i < this.pagination.current_page; i++) {
        if (this.productsPaginated[i]) {
          products.push(...this.productsPaginated[i])
        }
      }
      return products
    }
  },
})
